import { StyleSheet, Text, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { Colors, Fonts } from "../../../styles";

export default function ButtonChoose({ title, onPress, iconName }) {
    return (
      <TouchableOpacity style={styles.button} onPress={onPress}>
        <Icon name={iconName} size={56} color={Colors.WHITE}/>
        <Text style={styles.text}>{title}</Text>
      </TouchableOpacity>
    );
  };

  const styles = StyleSheet.create({  
      button: {
        backgroundColor: Colors.SECONDARY,
        borderRadius: 8,
        margin: 8,
        padding: 12,
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      },
      text:{
        color: Colors.WHITE,
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "500",
        marginTop: "auto"
      }
})
